import React from 'react'
import {FaReact} from "react-icons/fa"
import {GrNode} from "react-icons/gr"
import {TbBrandReactNative} from "react-icons/tb"
import {MdOutlinePublishedWithChanges} from "react-icons/md"
import {DiHtml53DEffects,DiJavascript1} from "react-icons/di"
const Services = () => {
  return (
    <section id="services" class="services">
            <div class="container">
                <div class="section-title">
                    <h2>Services</h2>
                    <p>These are the skills in which I'm expert and offering, my services are :</p>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up">
                        <div class="icon"><i><DiHtml53DEffects/></i></div>
                        <h4 class="title"><a href="#"> HTML5 / CSS3</a></h4>
                        <p class="description">Expert in HTML and CSS for styling. I also use Matarial UI, Chakra UI, Tailwind css and many other awesome tools.</p>
                    </div>
                    <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="100">
                        <div class="icon"><i><DiJavascript1/></i></div>
                        <h4 class="title"><a href="#">JavaScript</a></h4>
                        <p class="description">Build the logic of your programs using JavaScript.</p>
                    </div>
                    <div class="col-lg-4 col-md-6 icon-box" data-aos="fade-up" data-aos-delay="300">
                        <div class="icon"><i><GrNode/></i></div>
                        <h4 class="title"><a href="#">Node JS</a></h4>
                        <p class="description">Recommended and consulted with clients on the most appropriate Back-End developer.</p>
                    </div>
                </div>
            </div>
        </section>
  )
}

export default Services